module.exports = __webpack_public_path__ + "img/refresh-1.7f94d669.png";